var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.99918V16.0008C20.9996 16.3516 20.9071 16.6962 20.7315 16.9999C20.556 17.3036 20.3037 17.5558 20 17.7312L13.0277 21.7161V12.4383L20.9985 7.92258C20.9995 7.94807 21 7.97361 21 7.99918Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9067 6.21549L13 2.268C12.696 2.09243 12.3511 2 12 2C11.6489 2 11.304 2.09243 11 2.268L8.69081 3.58781L16.6302 8.07174L19.9067 6.21549Z",
    fill: "#1890FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67241 4.74142L4.09332 6.21549L12 10.6949L14.5761 9.23545L6.8618 4.87864C6.79205 4.83925 6.7288 4.79306 6.67241 4.74142Z",
    fill: "#1890FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00155 7.92258L10.9723 12.4383V21.7161L4 17.7312C3.69626 17.5558 3.44398 17.3036 3.26846 16.9999C3.09294 16.6962 3.00036 16.3516 3 16.0008V7.99918C3.00003 7.97361 3.00054 7.94807 3.00155 7.92258Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.269437b9ba9ba328730929df09e18d96.svg";
export { ForwardRef as ReactComponent };